var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vs-progress--background",class:[`vs-progress-${_vm.color}`,{
    'indeterminate':_vm.indeterminate,
  }],style:(_vm.styleConProgress)},[_c('div',{staticClass:"vs-progress--foreground",style:(_vm.styleProgress)}),(_vm.indeterminate)?_c('div',{staticClass:"vs-progress--indeterminate",style:(_vm.styleProgress)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }